let lenisRef = null;
const GERVIX_MARKET_ROOT = document.getElementById('gervix-root');
const GERVIX_US_MARKET = GERVIX_MARKET_ROOT?.dataset.market === 'US';
const GERVIX_LANGUAGE = window.GERVIX_LANGUAGE || ((new URLSearchParams(location.search).get('lang') === 'es' || /(?:^|; )gervix_language=es(?:;|$)/.test(document.cookie)) ? 'es' : 'en');
const GERVIX_US_SPANISH = GERVIX_US_MARKET && GERVIX_LANGUAGE === 'es';
const gervixUsText = (english, spanish) => GERVIX_US_SPANISH ? spanish : english;
function prepareGervixMarketCopy() {
    if (!GERVIX_US_MARKET || !GERVIX_MARKET_ROOT)
        return;
    document.documentElement.lang = GERVIX_US_SPANISH ? 'es-US' : 'en-US';
    const copy = {
        'INICIANDO SISTEMA': 'STARTING SYSTEM', 'CARGANDO EXPERIENCIA': 'LOADING EXPERIENCE',
        'Preparando tu descanso…': 'Preparing your rest…', 'GERVIX · COL': 'GERVIX · USA',
        'KIT MAGNÉTICO': 'MAGNETIC KIT', 'SIN FÁRMACOS': 'DRUG FREE', 'REUTILIZABLE': 'REUSABLE',
        'Beneficios': 'Benefits', 'Cómo funciona': 'How it works', 'Reseñas': 'Reviews', 'Comprar': 'Shop',
        'Pedir contraentrega': 'SHOP NOW', 'Respiración nasal · Descanso profundo · Colombia': 'Nasal breathing · Deep rest · United States',
        'Tu cuerpo nunca': 'Your body never', 'descansa de verdad': 'truly rests', 'porque de noche': 'because at night it', 'lucha por respirar': 'struggles to breathe',
        'RESPIRA POR LA NARIZ': 'BREATHE THROUGH YOUR NOSE', 'Aire libre toda la noche, sin esfuerzo': 'Clear airflow all night, without effort',
        'SUEÑO CONTINUO': 'UNINTERRUPTED SLEEP', 'Sin despertares ni bajones de oxígeno': 'Fewer wake-ups and better airflow',
        'RECUPERACIÓN REAL': 'REAL RECOVERY', 'Tu cuerpo se regenera mientras duerme': 'Your body recovers while you sleep',
        'ENERGÍA AL DESPERTAR': 'WAKE UP ENERGIZED', 'Amaneces enfocado, no arrastrado': 'Wake up focused instead of drained',
        'CAMBIO': 'RESULT', 'RECUPERA TU DESCANSO PROFUNDO': 'RESTORE YOUR DEEPEST SLEEP', 'Pedir ahora': 'SHOP NOW',
        'MENOS RONQUIDOS': 'LESS SNORING', 'PAGO CONTRA ENTREGA': 'SECURE ONLINE PAYMENT', 'ENVÍO GRATIS': 'FREE SHIPPING', 'GARANTÍA 30 DÍAS': '30-DAY GUARANTEE',
        'No estás agotado solo porque duermes mal — ': "You are not exhausted just because you sleep poorly — ",
        'duermes mal porque tu cuerpo pasa la noche luchando por respirar': 'you sleep poorly because your body spends the night struggling to breathe',
        '. Cuando el aire no entra libre por tu nariz, tu sueño se rompe, tu cuerpo no se recupera y despiertas con la sensación de no haber descansado. GERVIX abre tus fosas nasales con imanes suaves para que ': '. When air cannot flow freely through your nose, your sleep is interrupted, your body cannot recover, and you wake up feeling unrested. GERVIX gently supports your nasal passages with magnets so ',
        'tu cuerpo por fin descanse de verdad': 'your body can finally get real rest',
        'Sujeción magnética': 'Magnetic support', 'Dos imanes suaves que abren el paso del aire por tu nariz sin invadir. Toda la noche, sin moverse.': 'Two gentle magnets support nasal airflow without anything inside your nose. Stable all night.',
        'Respiración libre': 'Clearer breathing', 'Recupera el flujo nasal que tu cuerpo necesita para entrar en descanso profundo real.': 'Support the nasal airflow your body needs to reach deeper, more restorative sleep.',
        'Sin fármacos': 'Drug free', 'Nada de pastillas, sprays ni aparatos. Solo tu respiración funcionando como debería.': 'No pills, sprays, or noisy devices. Just natural nasal breathing.',
        'Reutilizable': 'Reusable', 'La usas noche tras noche. Una sola compra que trabaja por ti durante meses.': 'Use it night after night. One reusable system designed to last for months.',
        'BENEFICIOS PRINCIPALES': 'MAIN BENEFITS', 'Más que dejar': 'More than less', 'de roncar': 'snoring',
        'Sueño profundo continuo': 'Continuous deep sleep', 'Menos despertares, más fases REM, cuerpo recuperado al amanecer.': 'Fewer interruptions, more restorative sleep, and a recovered body in the morning.',
        'Energía y foco de día': 'Daytime energy and focus', 'Cuando duermes bien de verdad rindes distinto — mente clara y cuerpo listo.': 'When you truly sleep well, you perform differently — clear mind and ready body.',
        'Menos ronquidos': 'Less snoring', 'Al abrir las vías nasales bajan las vibraciones que rompen el descanso de los dos.': 'Supporting nasal airflow can reduce the vibrations that disturb both sleepers.',
        'Recuperación y rendimiento': 'Recovery and performance', 'Más oxígeno de noche = mejor recuperación física para entrenamiento y día a día.': 'Better nighttime airflow supports physical recovery for training and daily life.',
        'CARACTERÍSTICAS': 'FEATURES', 'Así es nuestra tira': 'Meet our magnetic', 'nasal magnética': 'nasal strip',
        'Tecnología de elevación magnética': 'Magnetic lift technology', 'Microimanes que mantienen la nariz abierta y dejan entrar más aire en cada respiración.': 'Micro-magnets gently support the nose and help more air flow with every breath.',
        'Resistente al agua y al sudor': 'Water and sweat resistant', 'Se mantiene firme incluso con calor, humedad o durante el ejercicio.': 'Designed to stay secure through heat, humidity, sleep, and exercise.',
        'Hipoalergénica y suave con la piel': 'Skin-friendly and gentle', 'Pensada para todo tipo de piel y para usarse cómodamente toda la noche.': 'Made for comfortable overnight use and designed with sensitive skin in mind.',
        'Sin nada dentro de la nariz': 'Nothing inside your nose', 'Se usa por fuera, sobre la nariz. Sin molestias, sin intrusión, sin incomodidad.': 'Worn externally over the nose, without intrusive plugs or internal devices.',
        'RESEÑAS': 'REVIEWS', 'Personas que volvieron': 'People who returned', 'a descansar de verdad': 'to truly restful sleep',
        'Si tu cuerpo pasa la noche ': 'If your body spends the night ', 'luchando por respirar': 'struggling to breathe', ', no importa cuántas horas duermas: nunca termina de recuperarse. No es tu edad. Es tu nariz.': ', the number of hours you sleep is not enough for full recovery. It is not just age. It may be your nasal airflow.',
        'QUÉ INCLUYE TU KIT': 'WHAT YOUR KIT INCLUDES', 'Todo para que tu cuerpo': 'Everything your body needs', 'vuelva a descansar': 'to rest again',
        '30 pares de parches adhesivos': '30 pairs of adhesive patches', 'Adhesivo de grado médico, cómodo incluso en pieles sensibles. Un mes de descanso por kit.': 'Skin-friendly adhesive designed for comfortable use, including sensitive skin.',
        'Bandas magnéticas reutilizables': 'Reusable magnetic bands', 'Cuatro tamaños (S2, M1, M2, L1) para un ajuste firme que no se mueve en toda la noche.': 'Four sizes (S2, M1, M2, L1) for a secure and comfortable fit throughout the night.',
        'Aplicador magnético': 'Magnetic applicator', 'Coloca los imanes en el punto exacto en segundos, sin buscar ni tantear.': 'Position the magnets precisely in seconds with an easy applicator.',
        'APLICACIÓN EN 4 PASOS': 'HOW TO APPLY · 4 STEPS', 'Se pone en segundos': 'Apply it in seconds', 'y trabaja toda la noche': 'and wear it all night',
        'Limpia': 'Clean', 'Limpia y seca la zona de la nariz para que el adhesivo agarre perfecto.': 'Clean and dry the nose area so the adhesive can hold properly.',
        'Aplica': 'Apply', 'Coloca los parches magnéticos a ambos lados de las fosas nasales.': 'Place the magnetic patches on both sides of your nostrils.',
        'Alinea': 'Align', 'Verifica que los imanes queden simétricos y firmes en su sitio.': 'Make sure both magnets are aligned, symmetrical, and secure.',
        'Ajusta': 'Fit', 'Pon el dilatador magnético hasta sentir la sujeción suave y estable.': 'Attach the magnetic dilator until the fit feels gentle and stable.',
        'LLEVA MÁS, AHORRA MÁS': 'MORE VALUE · MORE SAVINGS', 'Elige tu kit': 'Choose your kit',
        'Que tu cuerpo descanse esta noche': 'Let your body rest tonight', 'Pídelo hoy y pagas cuando llegue a tu puerta. Garantía de 30 días — los detalles están en los términos.': 'Order today with free U.S. shipping and secure online payment. 30-day guarantee — see terms for details.',
        'Pedir mi GERVIX': 'CHOOSE MY GERVIX', 'ENVÍO GRATIS A COLOMBIA': 'FREE SHIPPING IN THE UNITED STATES', 'PAGO CONTRA ENTREGA': 'SECURE ONLINE CHECKOUT',
        'Dile adiós a la sensación de ahogo y falta de aire': 'Say goodbye to restricted airflow and nighttime breathing discomfort',
        'Entrena con mas oxígeno y menos fatiga muscular': 'Train with better airflow and less muscle fatigue',
        'Sueño profundo y sin ronquidos, despierta con energía real': 'Deeper, quieter sleep so you wake up with real energy',
        'Ajuste perfecto y seguro, materiales de grado médico': 'Secure, comfortable fit with medical-grade materials',
        'TIRAS NASALES MAGNÉTICAS': 'MAGNETIC NASAL STRIPS', 'Colombia · WhatsApp de soporte': 'United States · Online support',
        'Política de devoluciones': 'Refund policy', 'Términos de servicio': 'Terms of service', 'Política de envío': 'Shipping policy',
        'Este producto no es un tratamiento médico ni sustituye la consulta con un profesional de la salud. Si sospechas apnea del sueño u otra condición, consulta a un especialista. Los resultados son orientativos y pueden variar según la persona. GERVIX ayuda a facilitar la respiración nasal; no cura ni elimina de forma garantizada los ronquidos o la apnea.': 'This product is not a medical treatment and does not replace advice from a healthcare professional. If you suspect sleep apnea or another condition, consult a specialist. Results vary. GERVIX supports nasal breathing and does not claim to cure snoring or sleep apnea.',
        'Todos los derechos reservados.': 'All rights reserved.'
    };
    const spanishOnly = {
        'STARTING EXPERIENCE': 'INICIANDO EXPERIENCIA', 'PREPARING YOUR EXPERIENCE': 'PREPARANDO TU EXPERIENCIA',
        'Pedir contraentrega': 'COMPRAR AHORA', 'Pedir ahora': 'COMPRAR AHORA',
        'Respiración nasal · Descanso profundo · Colombia': 'Respiración nasal · Descanso profundo · Estados Unidos',
        'PAGO CONTRA ENTREGA': 'PAGO SEGURO EN LÍNEA', 'ENVÍO GRATIS A COLOMBIA': 'ENVÍO GRATIS EN ESTADOS UNIDOS',
        'Colombia · WhatsApp de soporte': 'Estados Unidos · Soporte en línea',
        'GERVIX · USA': 'GERVIX · EE. UU.', 'SHOP NOW': 'COMPRAR AHORA',
        'Nasal breathing · Deep rest · United States': 'Respiración nasal · Descanso profundo · Estados Unidos',
        'SECURE ONLINE PAYMENT': 'PAGO SEGURO EN LÍNEA', 'SECURE ONLINE CHECKOUT': 'CHECKOUT SEGURO EN LÍNEA',
        'FREE SHIPPING': 'ENVÍO GRATIS', '30-DAY GUARANTEE': 'GARANTÍA DE 30 DÍAS',
        'FREE SHIPPING IN THE UNITED STATES': 'ENVÍO GRATIS EN ESTADOS UNIDOS', 'United States · Online support': 'Estados Unidos · Soporte en línea',
        'FREE U.S. SHIPPING': 'ENVÍO GRATIS EN ESTADOS UNIDOS', 'DAILY DEAL': 'OFERTA DEL DÍA',
        'DAILY OFFER ENDS AT MIDNIGHT': 'LA OFERTA DEL DÍA TERMINA A MEDIANOCHE', 'TODAY ONLY': 'SOLO HOY', 'NEW YORK TIME': 'HORA DE NUEVA YORK', 'OFFER ENDS IN': 'LA OFERTA TERMINA EN',
        'Breathe Better.': 'Respira Mejor.', 'Sleep Deeper.': 'Duerme Profundamente.',
        'Start with the complete black GERVIX Premium Kit, then personalize your order with only the extras you want.': 'Empieza con el Kit Premium GERVIX negro completo y personaliza tu pedido únicamente con los extras que quieras.',
        'Supports clearer nasal airflow and more comfortable breathing': 'Favorece un flujo nasal más libre y una respiración más cómoda',
        'Train with better airflow and less muscle fatigue': 'Entrena con mejor respiración y menos fatiga muscular',
        'Deeper, quieter sleep so you wake up with real energy': 'Sueño más profundo y silencioso para despertar con energía real',
        'Secure, comfortable fit with medical-grade materials': 'Ajuste seguro y cómodo con materiales de grado médico',
        'YOUR KIT': 'TU KIT', 'Included in your order': 'Incluido en tu pedido', 'REMOVE': 'QUITAR', 'ADD': 'AÑADIR',
        'PREMIUM KIT': 'KIT PREMIUM', 'BEST VALUE': 'MEJOR OFERTA', 'Black GERVIX system + 30 adhesive patches · 30 days': 'Sistema GERVIX negro + 30 parches adhesivos · 30 días',
        'EXTRA PATCHES': 'PARCHES ADICIONALES', 'Optional 120-patch refill': 'Repuesto opcional de 120 parches',
        'PATCH ADD-ONS': 'PARCHES ADICIONALES', 'ADD ONLY IF YOU WANT MORE': 'AÑADE SOLO SI QUIERES MÁS',
        '120 extra patches': '120 parches adicionales', 'Stay stocked for longer': 'Ten repuestos por más tiempo',
        'Your order': 'Tu pedido', 'Premium Kit': 'Kit Premium', 'BUY NOW': 'COMPRAR AHORA', 'SELECT AN ITEM': 'SELECCIONA UN PRODUCTO',
        'Selected items ready': 'Productos seleccionados listos', 'Secure checkout opens after one optional offer.': 'El checkout seguro se abrirá después de una oferta opcional.',
        'NEXT: ONE QUICK OPTIONAL OFFER → SECURE CHECKOUT': 'SIGUIENTE: UNA OFERTA OPCIONAL RÁPIDA → CHECKOUT SEGURO',
        'SECURE U.S. CHECKOUT': 'CHECKOUT SEGURO PARA EE. UU.', 'Your order is displayed and charged in U.S. dollars (USD).': 'Tu pedido se muestra y se cobra en dólares estadounidenses (USD).',
        'Secure checkout with all available payment methods · Free shipping anywhere in the United States': 'Checkout seguro con todos los métodos de pago disponibles · Envío gratis en todo Estados Unidos',
        '4.8 stars from 19,243 reviews in the United States': '4.8 estrellas de 19.243 reseñas en Estados Unidos', 'stars from 19,243 reviews': 'estrellas de 19.243 reseñas',
        'ONE-TIME CHECKOUT OFFER': 'OFERTA ÚNICA ANTES DEL CHECKOUT', 'ADD THE BREATHING TRAINER?': '¿DESEAS AÑADIR EL ENTRENADOR RESPIRATORIO?',
        'Train stronger, more controlled breathing and complete your nightly routine for only $6 more.': 'Entrena una respiración más fuerte y controlada y completa tu rutina nocturna por solo $6 adicionales.',
        'EXCLUSIVE ADD-ON': 'ADICIONAL EXCLUSIVO', 'Current order': 'Pedido actual', 'YES, ADD IT FOR $6': 'SÍ, AÑADIR POR $6',
        'NO THANKS — CONTINUE TO CHECKOUT': 'NO, GRACIAS — CONTINUAR AL CHECKOUT',
        'Secure checkout next · No account required · Free U.S. shipping': 'Checkout seguro a continuación · Sin crear cuenta · Envío gratis en EE. UU.',
        'Close offer': 'Cerrar oferta', 'WHAT IS INCLUDED': 'QUÉ INCLUYE', '30-DAY PREMIUM KIT': 'KIT PREMIUM DE 30 DÍAS',
        'CLEAN · APPLY · ALIGN · FIT': 'LIMPIA · APLICA · ALINEA · AJUSTA', 'BUILD MY ORDER': 'ARMAR MI PEDIDO', 'Verified purchase': 'Compra verificada',
        'Order today with free U.S. shipping and secure online payment. 30-day guarantee — see terms for details.': 'Pide hoy con envío gratis en Estados Unidos y pago seguro en línea. Garantía de 30 días — consulta los términos.'
    };
    const translations = GERVIX_US_SPANISH
        ? Object.assign(Object.fromEntries(Object.entries(copy).map(([spanish, english]) => [english, spanish])), spanishOnly)
        : copy;
    const keys = Object.keys(translations).sort((a, b) => b.length - a.length);
    const walker = document.createTreeWalker(GERVIX_MARKET_ROOT, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
        if (node.parentElement?.closest('script,style')) return;
        let value = node.nodeValue || '';
        keys.forEach((key) => { if (value.includes(key)) value = value.split(key).join(translations[key]); });
        node.nodeValue = value;
    });
}
prepareGervixMarketCopy();
const GERVIX_INTRO_TOTAL_MS = 2500;
const GERVIX_INTRO_FADE_MS = 150;
const gervixIntroStartedAt = performance.now();
// La experiencia GERVIX requiere conservar su secuencia visual completa en todos los dispositivos.
const GERVIX_REDUCED_MOTION = false;
const GERVIX_FINE_POINTER = window.matchMedia && window.matchMedia("(pointer: fine)").matches;
const GERVIX_ENHANCED_MOTION = GERVIX_FINE_POINTER && !GERVIX_REDUCED_MOTION && window.innerWidth >= 900;
const GERVIX_CLARITY_TAGS = new Set(['market', 'page', 'locale', 'device', 'motion', 'viewport', 'page_height', 'section', 'location', 'offer', 'addons', 'upsell', 'currency', 'action', 'tier', 'payment_method', 'percent', 'status']);
const GERVIX_CLARITY_ONCE = new Set();
function gervixClarityValue(value) {
    if (typeof value === 'boolean') return value ? 'yes' : 'no';
    return String(value == null ? '' : value).replace(/[^a-zA-Z0-9_ .,:/-]/g, '').slice(0, 120) || 'none';
}
function gervixClaritySet(key, value) {
    if (typeof window.clarity !== 'function' || !GERVIX_CLARITY_TAGS.has(key)) return;
    try { window.clarity('set', 'gervix_' + key, gervixClarityValue(value)); } catch (error) { /* Analytics never interrupts the experience. */ }
}
function gervixClarityEvent(name, params, options) {
    if (typeof window.clarity !== 'function') return;
    const eventName = String(name || 'interaction').toLowerCase().replace(/[^a-z0-9_]+/g, '_').slice(0, 80);
    if (options && options.once) {
        if (GERVIX_CLARITY_ONCE.has(eventName)) return;
        GERVIX_CLARITY_ONCE.add(eventName);
    }
    Object.entries(params || {}).forEach(([key, value]) => gervixClaritySet(key, value));
    try {
        window.clarity('set', 'gervix_last_action', eventName);
        window.clarity('event', 'gervix_' + eventName);
        if (options && options.upgrade) window.clarity('upgrade', 'gervix_' + eventName);
    } catch (error) { /* Analytics never interrupts the experience. */ }
}
function gervixClarityDimensions() {
    const width = window.innerWidth || document.documentElement.clientWidth || 0;
    const height = Math.max(document.documentElement.scrollHeight, document.body ? document.body.scrollHeight : 0);
    gervixClaritySet('viewport', width < 600 ? 'mobile' : width < 1024 ? 'tablet' : 'desktop');
    gervixClaritySet('page_height', height < 4000 ? 'short' : height < 8000 ? 'medium' : 'long');
}
function clarityTag(page) {
    gervixClaritySet('section', page);
    gervixClarityEvent('section_' + page, { section: page }, { once: true });
}
function initGervixClarity() {
    if (!GERVIX_MARKET_ROOT || typeof window.clarity !== 'function') return;
    gervixClaritySet('market', GERVIX_US_MARKET ? 'US' : 'CO');
    gervixClaritySet('page', GERVIX_US_MARKET ? 'landing_us' : 'landing_co');
    gervixClaritySet('locale', document.documentElement.lang || navigator.language || (GERVIX_US_MARKET ? 'en-US' : 'es-CO'));
    gervixClaritySet('device', GERVIX_FINE_POINTER ? 'pointer' : 'touch');
    gervixClaritySet('motion', GERVIX_ENHANCED_MOTION ? 'enhanced' : 'standard');
    gervixClarityDimensions();
    gervixClarityEvent('landing_ready', { market: GERVIX_US_MARKET ? 'US' : 'CO' }, { once: true });
    if ('IntersectionObserver' in window) {
        const seenSections = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) return;
                const section = entry.target;
                const sectionName = section.id || Array.from(section.classList).find((name) => name && name !== 'is-visible') || 'content';
                clarityTag(sectionName);
                seenSections.unobserve(section);
            });
        }, { threshold: 0.18 });
        GERVIX_MARKET_ROOT.querySelectorAll('section').forEach((section) => seenSections.observe(section));
    }
    let resizeTimer = 0;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(gervixClarityDimensions, 250);
    }, { passive: true });
    window.addEventListener('load', () => {
        requestAnimationFrame(() => {
            gervixClarityDimensions();
            gervixClarityEvent('page_fully_loaded', { status: 'ready' }, { once: true });
        });
    }, { once: true });
    let reportedErrors = 0;
    const reportTechnicalError = (status) => {
        if (reportedErrors >= 3) return;
        reportedErrors += 1;
        gervixClarityEvent('javascript_error', { market: GERVIX_US_MARKET ? 'US' : 'CO', status }, { upgrade: true });
    };
    window.addEventListener('error', (event) => reportTechnicalError(event && event.target && event.target !== window ? 'resource_error' : 'script_error'), true);
    window.addEventListener('unhandledrejection', () => reportTechnicalError('promise_error'));
}
initGervixClarity();
function initGervix() {
    const gsap = window.gsap, ScrollTrigger = window.ScrollTrigger, Lenis = window.Lenis;
    const $ = (s) => document.querySelector(s);
    const $$ = (s) => Array.from(document.querySelectorAll(s));
    /* Cursor */
    (function () {
        const cur = document.getElementById("cur"), dot = document.getElementById("curDot");
        if (!GERVIX_FINE_POINTER || !cur || !dot)
            return;
        let mx = innerWidth / 2, my = innerHeight / 2, cx = mx, cy = my;
        addEventListener("mousemove", (e) => { mx = e.clientX; my = e.clientY; dot.style.transform = `translate(${mx}px,${my}px) translate(-50%,-50%)`; });
        (function loop() { if (!document.hidden) { cx += (mx - cx) * .18; cy += (my - cy) * .18; cur.style.transform = `translate(${cx}px,${cy}px) translate(-50%,-50%)`; } requestAnimationFrame(loop); })();
        document.addEventListener("mouseover", (e) => { if (e.target.closest("[data-cursor],a,button"))
            cur.classList.add("grow"); });
        document.addEventListener("mouseout", (e) => { if (e.target.closest("[data-cursor],a,button"))
            cur.classList.remove("grow"); });
    })();
    /* Magnetic */
    (GERVIX_FINE_POINTER ? $$(".btn,.hero-cta,.nav-cta,.pbtn,.submit-btn") : []).forEach((el) => {
        const strength = 18;
        el.addEventListener("mousemove", (e) => {
            const r = el.getBoundingClientRect();
            const x = (e.clientX - r.left - r.width / 2) / r.width * strength;
            const y = (e.clientY - r.top - r.height / 2) / r.height * strength;
            el.style.transform = `translate(${x}px,${y}px)`;
            const sp = el.querySelector("span");
            if (sp)
                sp.style.transform = `translate(${x * .4}px,${y * .4}px)`;
        });
        el.addEventListener("mouseleave", () => { el.style.transform = ""; const sp = el.querySelector("span"); if (sp)
            sp.style.transform = ""; });
    });
    /* Split words -> chars (spaced) */
    const splitSpaced = (el) => {
        const text = el.textContent || "";
        el.textContent = "";
        [...text].forEach((ch) => {
            const s = document.createElement("span");
            s.className = "sc";
            s.textContent = ch === " " ? "\u00A0" : ch;
            el.appendChild(s);
        });
        return Array.from(el.querySelectorAll(".sc"));
    };
    const splitLines = (el) => {
        // Split each line of innerHTML (separated by <br>) into spaced chars
        const html = el.innerHTML;
        const parts = html.split(/<br\s*\/?>/i);
        el.innerHTML = "";
        parts.forEach((part, idx) => {
            const line = document.createElement("span");
            line.className = "sl";
            [...part.replace(/<[^>]+>/g, "")].forEach((ch) => {
                const s = document.createElement("span");
                s.className = "sc";
                s.textContent = ch === " " ? "\u00A0" : ch;
                line.appendChild(s);
            });
            el.appendChild(line);
            if (idx < parts.length - 1)
                el.appendChild(document.createElement("br"));
        });
        return Array.from(el.querySelectorAll(".sc"));
    };
    $$("[data-spaced]").forEach(splitSpaced);
    $$("[data-spaced-lines]").forEach(splitLines);
    /* WHY vertical letters */
    const whyHost = document.getElementById("whyVert");
    if (whyHost)
        (GERVIX_US_MARKET && !GERVIX_US_SPANISH ? "WHY GERVIX" : "POR QUÉ GERVIX").split("").forEach((c) => { const s = document.createElement("span"); s.className = "vchar"; s.textContent = c === " " ? "\u00A0" : c; whyHost.appendChild(s); });
    /* Rotator */
    const benefits = GERVIX_US_MARKET && !GERVIX_US_SPANISH ? [
        { n: "01", t: "RESTORE YOUR DEEPEST SLEEP" },
        { n: "02", t: "WAKE UP BALANCED AND ENERGIZED" },
        { n: "03", t: "STOP STRUGGLING TO BREATHE" },
    ] : [
        { n: "01", t: "RECUPERA TU DESCANSO PROFUNDO" },
        { n: "02", t: "AMANECE REGULADO Y CON ENERGÍA" },
        { n: "03", t: "DEJA DE LUCHAR POR RESPIRAR" },
    ];
    let bi = 0;
    const rn = document.getElementById("rotNum"), rname = document.getElementById("rotName");
    setInterval(() => {
        bi = (bi + 1) % benefits.length;
        rname.style.transition = "opacity .38s,transform .38s";
        rname.style.opacity = "0";
        rname.style.transform = "translateY(8px)";
        setTimeout(() => {
            rn.textContent = benefits[bi].n;
            rname.textContent = benefits[bi].t;
            rname.style.opacity = "1";
            rname.style.transform = "none";
        }, 380);
    }, 2600);
    /* Reviews */
    const reviews = GERVIX_US_MARKET && !GERVIX_US_SPANISH ? [
        { name: "Camila R.", city: "Miami, FL", q: "I FINALLY SLEEP THROUGH THE NIGHT", p: "I used to wake up tired after eight hours. GERVIX supports my nasal breathing all night and I wake up feeling genuinely rested." },
        { name: "Andrew M.", city: "Austin, TX", q: "MY RECOVERY FEELS DIFFERENT", p: "I train hard and recovery was difficult. After adding GERVIX to my nightly routine, I noticed a real difference in sleep quality." },
        { name: "Jenny P.", city: "San Diego, CA", q: "REAL ENERGY IN THE MORNING", p: "I was carrying fatigue every day. Now I sleep with fewer interruptions and start the day focused instead of drained." },
        { name: "Oscar D.", city: "Orlando, FL", q: "SIMPLE AND COMFORTABLE", p: "I tried sprays and uncomfortable devices. GERVIX is simple to apply and makes nasal breathing feel easier at night." },
        { name: "Valentina G.", city: "New York, NY", q: "A BETTER NIGHTLY ROUTINE", p: "The magnetic system is easy to use, comfortable, and has become an essential part of my bedtime routine." },
        { name: "Richard S.", city: "Denver, CO", q: "I WAKE UP FEELING FRESH", p: "I often woke up with a dry mouth and no energy. Supporting nasal breathing has helped me feel much fresher in the morning." },
        { name: "Marcela T.", city: "Houston, TX", q: "WE BOTH REST BETTER", p: "My partner's noisy breathing disturbed both of us. GERVIX helped support clearer nasal airflow and our nights feel calmer." },
        { name: "Julian A.", city: "Chicago, IL", q: "MY BODY CAN FINALLY REST", p: "I did not realize how much nighttime breathing affected my focus, energy, and mood until I changed my routine." },
    ] : [
        { name: "Camila R.", city: "Bogotá", q: "POR FIN DUERMO DE VERDAD", p: "Amanecía cansada aunque durmiera 8 horas. Con GERVIX respiro por la nariz toda la noche y me levanto como si hubiera dormido el doble." },
        { name: "Andrés M.", city: "Medellín", q: "MI CUERPO SE RECUPERA OTRA VEZ", p: "Entreno pesado y no lograba recuperarme. Empecé con GERVIX y el cambio en el descanso profundo se sintió desde la primera semana." },
        { name: "Jenny P.", city: "Cali", q: "AMANEZCO CON ENERGÍA REAL", p: "Vivía con cansancio arrastrado. Ahora duermo sin despertarme y el día lo empiezo con foco, no en piloto automático." },
        { name: "Óscar D.", city: "Barranquilla", q: "POR FIN ALGO QUE SÍ FUNCIONA", p: "Probé sprays, almohadas raras, de todo. GERVIX me abrió la respiración de noche y por primera vez en años duermo de un tirón." },
        { name: "Valentina G.", city: "Bucaramanga", q: "MI PAPÁ VOLVIÓ A DESCANSAR", p: "Amanecía agotado y de mal genio. Le regalé GERVIX, empezó a respirar por la nariz y hasta el humor le cambió." },
        { name: "Ricardo S.", city: "Pereira", q: "DEJÉ DE DESPERTARME MOLIDO", p: "Me despertaba con la boca seca y sin energía. Con GERVIX respiro por la nariz toda la noche y me levanto fresco de verdad." },
        { name: "Marcela T.", city: "Bogotá", q: "YA DORMIMOS LOS DOS", p: "Los ronquidos de mi pareja no me dejaban descansar. GERVIX abrió su respiración y ahora los dos amanecemos recuperados." },
        { name: "Julián A.", city: "Ibagué", q: "MI CUERPO POR FIN DESCANSA", p: "Vivía cansado sin saber por qué. Resulta que no respiraba bien de noche. Con GERVIX cambió todo — enfoque, energía, ánimo." },
    ];
    const card = (r) => {
        const ini = r.name.split(" ").map((x) => x[0]).slice(0, 2).join("");
        return `<div class="review-card"><div class="stars">★★★★★</div><div class="rq">${r.q}</div><p>"${r.p}"</p><div class="rmeta"><div class="ravatar">${ini}</div><div><div class="rname">${r.name}</div><div class="rverified">✓ ${GERVIX_US_MARKET && !GERVIX_US_SPANISH ? 'Verified purchase' : 'Compra verificada'} · ${r.city}</div></div></div></div>`;
    };
    const mq1 = document.getElementById("mq1"), mq2 = document.getElementById("mq2");
    if (mq1)
        mq1.innerHTML = reviews.map(card).join("") + reviews.map(card).join("");
    if (mq2)
        mq2.innerHTML = [...reviews].reverse().map(card).join("") + [...reviews].reverse().map(card).join("");
    const hasGSAP = gsap && ScrollTrigger;
    if (hasGSAP)
        gsap.registerPlugin(ScrollTrigger);
    if (Lenis && GERVIX_ENHANCED_MOTION) {
        lenisRef = new Lenis({ lerp: .09, smoothWheel: true });
        lenisRef.on("scroll", () => hasGSAP && ScrollTrigger.update());
        const raf = (t) => { lenisRef.raf(t); requestAnimationFrame(raf); };
        requestAnimationFrame(raf);
    }
    /* Intro */
    const introManaged = document.body.dataset.gervixIntroManaged === "true";
    const words = GERVIX_US_MARKET && !GERVIX_US_SPANISH ? ["BREATHE", "REST", "LIVE"] : ["RESPIRA", "DESCANSA", "VIVE"];
    let wi = 0;
    const subs = GERVIX_US_MARKET && !GERVIX_US_SPANISH ? ["Preparing your rest…", "Aligning nasal airflow…", "Loading a better night…"] : ["Preparando tu descanso…", "Alineando fosas nasales…", "Cargando noche perfecta…"];
    let si = 0;
    const wordEl = document.getElementById("introWord"), countEl = document.getElementById("introCount"), barEl = document.getElementById("introBar"), subEl = document.getElementById("introSub");
    const wordInt = introManaged ? 0 : setInterval(() => { wi = (wi + 1) % words.length; wordEl.style.animation = "none"; wordEl.offsetHeight; wordEl.style.animation = ""; wordEl.textContent = words[wi]; if (subEl) {
        si = (si + 1) % subs.length;
        subEl.style.opacity = "0";
        setTimeout(() => { subEl.textContent = subs[si]; subEl.style.opacity = ""; }, 160);
    } }, 900);
    let n = 0;
    const countInt = introManaged ? 0 : setInterval(() => {
        const progressDuration = GERVIX_INTRO_TOTAL_MS - GERVIX_INTRO_FADE_MS;
        n = Math.min(100, Math.round((performance.now() - gervixIntroStartedAt) / progressDuration * 100));
        countEl.textContent = String(n).padStart(3, "0");
        barEl.style.width = n + "%";
        if (n >= 100)
            clearInterval(countInt);
    }, 50);
    const RM = GERVIX_REDUCED_MOTION;
    const introStillVisible = performance.now() - gervixIntroStartedAt < GERVIX_INTRO_TOTAL_MS;
    if (hasGSAP && !RM && introStillVisible)
        $$(".hero .hl .sc").forEach((c) => { c.style.transform = "none"; c.style.opacity = "0"; });
    if (!RM && introStillVisible)
        document.body.classList.add("lock");
    // Safety: si algo falla, garantiza que el hero sea visible
    setTimeout(() => { $$(".hero .hl .sc").forEach((c) => { c.style.transform = ""; c.style.opacity = ""; }); document.body.classList.remove("lock"); const i = document.getElementById("intro"); if (i)
        i.style.display = "none"; const p = document.getElementById("introPanel"); if (p)
        p.style.display = "none"; }, 16000);
    const revealHero = () => {
        if (wordInt)
            clearInterval(wordInt);
        if (countInt)
            clearInterval(countInt);
        document.body.classList.remove("lock");
        lenisRef?.start();
        if (!hasGSAP || RM) {
            const i = document.getElementById("intro"), p = document.getElementById("introPanel");
            if (i)
                i.style.display = "none";
            if (p)
                p.style.display = "none";
            document.getElementById("gervix-root")?.classList.add("gsap-off");
            $$(".hero .sc").forEach((c) => { c.style.transform = "none"; c.style.opacity = "1"; });
            return;
        }
        const tl = gsap.timeline();
        tl.to("#intro", { opacity: 0, duration: .14, ease: "power1.out", onStart: () => { gsap.to(".hero .hl .sc", { opacity: 1, duration: .12, stagger: 0, ease: "none" }); }, onComplete: () => { const i = document.getElementById("intro"); if (i)
                i.style.display = "none"; const p = document.getElementById("introPanel"); if (p)
                p.style.display = "none"; } })
            .from("#heroProduct", { y: 28, scale: .97, opacity: 0, duration: .36, ease: "power2.out" }, "-=.06")
            .from(".hero-rotator", { y: 10, opacity: 0, duration: .28 }, "-=.22")
            .from(".hero-side", { opacity: 0, y: 6, duration: .24, stagger: .03 }, "-=.22")
            .fromTo(".fnote", { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: .3, stagger: .04, ease: "power2.out" }, "-=.18")
            .fromTo(".fconn", { strokeDasharray: 200, strokeDashoffset: 200, opacity: 0 }, { strokeDashoffset: 0, opacity: .55, duration: .38, stagger: .04, ease: "power1.out" }, "-=.28");
    };
    const elapsed = performance.now() - gervixIntroStartedAt;
    const revealDelay = RM ? 0 : Math.max(0, GERVIX_INTRO_TOTAL_MS - GERVIX_INTRO_FADE_MS - elapsed);
    setTimeout(revealHero, revealDelay);
    let headerFrame = 0;
    addEventListener("scroll", () => { if (headerFrame) return; headerFrame = requestAnimationFrame(() => { document.getElementById("header")?.classList.toggle("scrolled", scrollY > 40); headerFrame = 0; }); }, { passive: true });
    if (!hasGSAP) {
        document.getElementById("gervix-root")?.classList.add("gsap-off");
        return;
    }
    /* Reveal — reversible on scroll up */
    gsap.utils.toArray(".reveal:not(.offer-copy)").forEach((el) => gsap.fromTo(el, { y: 40, opacity: 0 }, { y: 0, opacity: 1, duration: 1, ease: "power3.out", overwrite: "auto", scrollTrigger: { trigger: el, start: "top 92%", toggleActions: "play none none reverse" } }));
    const offerCopy = document.querySelector(".offer-copy");
    if (offerCopy)
        gsap.fromTo(offerCopy, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: .65, ease: "power3.out", overwrite: "auto", scrollTrigger: { trigger: ".offer", start: "top 92%", toggleActions: "play none none reverse" } });
    /* Spaced titles reveal on scroll (except hero) */
    gsap.utils.toArray(".section-title[data-spaced-lines]").forEach((el) => {
        gsap.fromTo(el.querySelectorAll(".sc"), { yPercent: 110, opacity: 0 }, { yPercent: 0, opacity: 1, duration: .7, stagger: .015, ease: "power4.out", scrollTrigger: { trigger: el, start: "top 90%", toggleActions: "play none none reverse" } });
    });
    gsap.utils.toArray(".final-title[data-spaced]").forEach((el) => {
        gsap.fromTo(el.querySelectorAll(".sc"), { yPercent: 110, opacity: 0 }, { yPercent: 0, opacity: 1, duration: .7, stagger: .012, ease: "power4.out", scrollTrigger: { trigger: el, start: "top 90%", toggleActions: "play none none reverse" } });
    });
    const offerTitle = document.querySelector(".offer h2[data-spaced-lines]");
    if (offerTitle)
        gsap.fromTo(offerTitle.querySelectorAll(".sc"), { yPercent: 110, opacity: 0 }, { yPercent: 0, opacity: 1, duration: .6, stagger: .01, ease: "power4.out", scrollTrigger: { trigger: ".offer", start: "top 92%", toggleActions: "play none none reverse" } });
    /* Ensure ScrollTrigger positions are correct after images & fonts settle */
    setTimeout(() => ScrollTrigger.refresh(), 300);
    setTimeout(() => ScrollTrigger.refresh(), 1500);
    window.addEventListener("load", () => ScrollTrigger.refresh());
    /* Hero parallax */
    gsap.to("#heroProduct", { yPercent: -18, scale: 1.06, scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true } });
    gsap.to("#heroGlow", { scale: 1.25, opacity: .5, scrollTrigger: { trigger: ".hero", start: "top top", end: "bottom top", scrub: true } });
    gsap.to("#heroProduct", { y: "-=22", duration: 3, ease: "sine.inOut", repeat: -1, yoyo: true });
    gsap.to("#heroGlow", { scale: 1.07, duration: 4, ease: "sine.inOut", repeat: -1, yoyo: true });
    /* Floating notes drift */
    $$(".fnote").forEach((el, i) => {
        gsap.to(el, { y: "+=10", x: i % 2 ? "+=6" : "-=6", duration: 3 + i * 0.35, ease: "sine.inOut", repeat: -1, yoyo: true, delay: i * 0.2 });
    });
    /* Connector endpoints follow the product corners as it drifts */
    const connectors = [
        { el: document.querySelector(".fconn-tl"), start: [20, 26], corner: [37, 44], ctrl: [30, 30] },
        { el: document.querySelector(".fconn-tr"), start: [80, 26], corner: [63, 44], ctrl: [70, 30] },
        { el: document.querySelector(".fconn-bl"), start: [20, 74], corner: [37, 56], ctrl: [30, 70] },
        { el: document.querySelector(".fconn-br"), start: [80, 74], corner: [63, 56], ctrl: [70, 70] },
    ];
    const stage = document.querySelector(".hero-stage");
    const hpEl = document.getElementById("heroProduct");
    const hpImage = hpEl?.querySelector("img");
    // Órbita exterior: siguen la imagen animada, pero conservan aire alrededor del producto.
    const productAnchors = [[.125, .20], [.90, .16], [.125, .80], [.875, .80]];
    const updateConnectors = () => {
        if (!stage || !hpEl)
            return;
        const sR = stage.getBoundingClientRect();
        const pR = (hpImage || hpEl).getBoundingClientRect();
        const corners = productAnchors.map(([x, y]) => [
            ((pR.left + pR.width * x) - sR.left) / sR.width * 100,
            ((pR.top + pR.height * y) - sR.top) / sR.height * 100,
        ]);
        connectors.forEach((c, i) => {
            if (!c.el)
                return;
            const [ex, ey] = corners[i];
            const [sx, sy] = c.start;
            const [kx, ky] = c.ctrl;
            c.el.setAttribute("d", `M${sx} ${sy} Q ${kx} ${ky}, ${ex.toFixed(2)} ${ey.toFixed(2)}`);
        });
    };
    updateConnectors();
    gsap.ticker.add(updateConnectors);
    const hp = document.getElementById("heroProduct");
    if (GERVIX_ENHANCED_MOTION)
        $(".hero")?.addEventListener("mousemove", (e) => { const dx = e.clientX / innerWidth - .5, dy = e.clientY / innerHeight - .5; gsap.to(hp, { rotationY: dx * 14, rotationX: -dy * 10, x: dx * 24, duration: .6, transformPerspective: 800, ease: "power2.out", overwrite: "auto" }); });
    const op = document.getElementById("offerProduct");
    const om = document.getElementById("offerMedia");
    if (op && om && GERVIX_ENHANCED_MOTION) {
        om.addEventListener("mousemove", (e) => {
            const r = om.getBoundingClientRect();
            const dx = (e.clientX - r.left) / r.width - .5;
            const dy = (e.clientY - r.top) / r.height - .5;
            gsap.to(op, { rotationY: dx * 18, rotationX: -dy * 14, x: dx * 30, y: dy * 20, duration: .6, transformPerspective: 900, ease: "power2.out", overwrite: "auto" });
        });
        om.addEventListener("mouseleave", () => {
            gsap.to(op, { rotationY: 0, rotationX: 0, x: 0, y: 0, duration: .8, ease: "power3.out" });
        });
    }
    /* Manifiesto word reveal */
    const p = document.getElementById("introText");
    if (p) {
        const wrapWords = (node) => {
            Array.from(node.childNodes).forEach((cn) => {
                if (cn.nodeType === 3) {
                    const parts = (cn.textContent || "").split(/(\s+)/);
                    const f = document.createDocumentFragment();
                    parts.forEach((pt) => { if (pt.trim()) {
                        const w = document.createElement("span");
                        w.className = "w";
                        w.textContent = pt;
                        f.appendChild(w);
                    }
                    else
                        f.appendChild(document.createTextNode(pt)); });
                    node.replaceChild(f, cn);
                }
                else if (cn.nodeType === 1)
                    wrapWords(cn);
            });
        };
        wrapWords(p);
        gsap.fromTo(p.querySelectorAll(".w"), { opacity: .08 }, { opacity: 1, stagger: .045, ease: "none", scrollTrigger: { trigger: p, start: "top 90%", end: "bottom 48%", scrub: .45 } });
    }
    /* Step counter numbers */
    $$("[data-count]").forEach((el) => { const end = +(el.dataset.count || 0); const o = { v: 0 }; gsap.to(o, { v: end, duration: 1.1, ease: "power2.out", scrollTrigger: { trigger: el, start: "top 88%", toggleActions: "play none none reverse" }, onUpdate: () => { el.textContent = String(Math.round(o.v)).padStart(2, "0"); } }); });
    gsap.from(".vchar", { y: 90, opacity: 0, stagger: .05, duration: .9, ease: "power4.out", scrollTrigger: { trigger: ".why", start: "top 72%", toggleActions: "play none none reverse" } });
    /* Marquee reseñas */
    const m1 = document.getElementById("mq1"), m2 = document.getElementById("mq2");
    let base = 0;
    let w1 = m1 ? m1.scrollWidth / 2 : 1, w2 = m2 ? m2.scrollWidth / 2 : 1;
    const measureMarquees = () => { if (m1) w1 = Math.max(1, m1.scrollWidth / 2); if (m2) w2 = Math.max(1, m2.scrollWidth / 2); };
    window.addEventListener("resize", measureMarquees, { passive: true });
    if (m1 && m2 && !RM)
        gsap.ticker.add(() => { base += GERVIX_ENHANCED_MOTION ? 0.45 : 0.3; m1.style.transform = `translate3d(${-(base % w1)}px,0,0)`; m2.style.transform = `translate3d(${-(w2 - (base % w2))}px,0,0)`; });
    /* Rail horizontal "Apertura nasal magnética" — items entran/salen de pantalla al hacer scroll */
    const rail = document.getElementById("howRail");
    const howStage = document.getElementById("howStage");
    const howOrbit = document.getElementById("howOrbit");
    if (rail && howStage) {
        const items = Array.from(rail.querySelectorAll(".rzn"));
        let stepPx = 0; // distancia entre centros de items consecutivos
        let baseShift = 0; // desplazamiento para centrar el primer item en el stage
        const measure = () => {
            // Usamos offsetLeft/clientWidth (no dependen del transform aplicado al rail)
            const stageW = howStage.clientWidth;
            const c0 = items[0].offsetLeft + items[0].offsetWidth / 2;
            const c1 = items[1] ? items[1].offsetLeft + items[1].offsetWidth / 2 : c0 + 600;
            stepPx = c1 - c0;
            baseShift = stageW / 2 - c0;
        };
        const applyState = (p) => {
            const pc = Math.max(0, Math.min(1, p));
            const idx = pc * (items.length - 1);
            const shift = baseShift - idx * stepPx;
            rail.style.transform = `translate3d(${shift}px, 0, 0)`;
            if (howOrbit)
                howOrbit.style.transform = `translate(-50%, -50%) rotate(${(pc - 0.5) * 60}deg)`;
            const stageRect = howStage.getBoundingClientRect();
            const stageMid = stageRect.left + stageRect.width / 2;
            const half = stageRect.width / 2;
            items.forEach((el, i) => {
                // Distancia lógica al centro (no depende de getBoundingClientRect del frame previo)
                const dLog = i - idx;
                const norm = Math.max(-1.4, Math.min(1.4, (dLog * stepPx) / half));
                const opacity = Math.max(0.08, 1 - Math.abs(norm) * 1.1);
                const scale = Math.max(0.7, 1 - Math.abs(norm) * 0.28);
                const rot = norm * 10;
                el.style.opacity = String(opacity);
                el.style.transform = `translateY(${Math.abs(norm) * 20}px) rotate(${rot}deg) scale(${scale})`;
            });
        };
        // Estado inicial síncrono para evitar "flash" del item 1 llegando
        measure();
        applyState(0);
        // Re-medir cuando fuentes/imágenes terminen de cargar
        requestAnimationFrame(() => { measure(); applyState(0); });
        window.addEventListener("load", () => { measure(); applyState(0); ScrollTrigger.refresh(); });
        window.addEventListener("resize", () => { measure(); ScrollTrigger.refresh(); });
        ScrollTrigger.create({
            trigger: howStage,
            start: "top top",
            // Distancia reducida para que la animación pase más rápido (mejor conversión)
            end: () => "+=" + (window.innerHeight * (items.length * 0.45 + 0.2)),
            pin: howStage,
            pinSpacing: true,
            pinType: "transform",
            anticipatePin: 1,
            scrub: 0.15,
            invalidateOnRefresh: true,
            onRefresh: () => { measure(); applyState(0); },
            onUpdate: (self) => applyState(self.progress),
            onEnter: () => clarityTag("como-rueda"),
            onEnterBack: () => clarityTag("como-rueda"),
            onLeave: () => { applyState(1); clarityTag("landing"); },
            onLeaveBack: () => { applyState(0); clarityTag("landing"); },
        });
    }
    ScrollTrigger.refresh();
}


(function () {
  'use strict';
  var root = document.getElementById('gervix-root');
  if (!root || root.dataset.shopifyReady === 'true') return;
  root.dataset.shopifyReady = 'true';

  if (root.dataset.market === 'US') {
    var usShopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!usShopRoot.endsWith('/')) usShopRoot += '/';
    var usVariants = {
      premium: root.getAttribute('data-us-premium-variant'),
      patches_120: root.getAttribute('data-us-patches-120-variant'),
      total_pack: root.getAttribute('data-us-total-pack-variant')
    };
    var usTrack = function (name, params) {
      gervixClarityEvent(name, params, { upgrade: name === 'checkout_start' });
      if (typeof window.fbq !== 'function') return;
      try { window.fbq('trackCustom', name, params || {}); } catch (error) { /* Tracking never interrupts navigation. */ }
    };
    root.querySelectorAll('.nav-cta,.hero-cta,.final .btn-lg').forEach(function (button) {
      button.setAttribute('type', 'button');
      button.addEventListener('click', function () {
        usTrack('cta_click', { market: 'US', location: button.closest('section') ? button.closest('section').className : 'navigation' });
        document.getElementById('comprar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    var usSelection = { premium: true, patches: false };
    var usPrices = { premium: 34.47, patches_120: 24.47, upsell: 6, total_pack: 40.47 };
    var usBuyButton = document.getElementById('GervixUsBuy');
    var usTotal = root.querySelector('[data-us-buy-total]');
    var usSummary = root.querySelector('[data-us-selection-summary]');
    var usError = root.querySelector('[data-us-buy-error]');
    var usPremiumCard = root.querySelector('[data-us-premium-card]');
    var usUpsellModal = document.getElementById('GervixUsUpsellModal');
    var usUpsellDialog = usUpsellModal && usUpsellModal.querySelector('.us-upsell-dialog');
    var usUpsellAccept = usUpsellModal && usUpsellModal.querySelector('[data-us-upsell-accept]');
    var usUpsellDecline = usUpsellModal && usUpsellModal.querySelector('[data-us-upsell-decline]');
    var usUpsellError = usUpsellModal && usUpsellModal.querySelector('[data-us-upsell-error]');
    var usLastFocus = null;
    var usCheckoutPending = false;
    function usFormat(value) { return '$' + value.toFixed(2); }
    function usSelectionTotal() { return (usSelection.premium ? usPrices.premium : 0) + (usSelection.patches ? usPrices.patches_120 : 0); }
    function usSelectionText() {
      var items = [];
      if (usSelection.premium) items.push(gervixUsText('Premium Kit', 'Kit Premium'));
      if (usSelection.patches) items.push(gervixUsText('120 extra patches', '120 parches adicionales'));
      return items.length ? items.join(' + ') : gervixUsText('No items selected', 'Ningún producto seleccionado');
    }
    function refreshUsSelection() {
      root.querySelectorAll('[data-us-premium-toggle]').forEach(function (button) {
        button.classList.toggle('is-selected', usSelection.premium);
        button.setAttribute('aria-pressed', String(usSelection.premium));
        var action = button.querySelector('[data-us-premium-action]');
        if (action) action.textContent = usSelection.premium ? gervixUsText('REMOVE', 'QUITAR') : gervixUsText('ADD', 'AÑADIR');
      });
      if (usPremiumCard) usPremiumCard.classList.toggle('is-selected', usSelection.premium);
      var premiumStatus = root.querySelector('[data-us-premium-status]');
      if (premiumStatus) premiumStatus.textContent = usSelection.premium ? gervixUsText('Included in your order', 'Incluido en tu pedido') : gervixUsText('Not included', 'No incluido');
      root.querySelectorAll('[data-us-addon]').forEach(function (button) {
        var active = usSelection.patches;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
        var action = button.querySelector('[data-us-addon-action]');
        if (action) action.textContent = active ? gervixUsText('REMOVE', 'QUITAR') : gervixUsText('ADD', 'AÑADIR');
      });
      var total = usSelectionTotal();
      if (usTotal) usTotal.textContent = usFormat(total);
      if (usSummary) usSummary.textContent = usSelectionText();
      if (usBuyButton) {
        var hasItems = usSelection.premium || usSelection.patches;
        usBuyButton.disabled = !hasItems;
        usBuyButton.innerHTML = hasItems ? gervixUsText('BUY NOW · ', 'COMPRAR AHORA · ') + '<span data-us-buy-total>' + usFormat(total) + '</span>' : gervixUsText('SELECT AN ITEM', 'SELECCIONA UN PRODUCTO');
        usTotal = root.querySelector('[data-us-buy-total]');
      }
      if (usError) usError.textContent = '';
    }
    root.querySelectorAll('[data-us-premium-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var removing = usSelection.premium;
        usSelection.premium = !usSelection.premium;
        usTrack('cta_click', { market: 'US', offer: 'premium', action: removing ? 'remove_item' : 'add_item', currency: 'USD' });
        refreshUsSelection();
      });
    });
    root.querySelectorAll('[data-us-addon]').forEach(function (button) {
      button.addEventListener('click', function () {
        var key = button.dataset.usAddon;
        var removing = usSelection.patches;
        usSelection.patches = !usSelection.patches;
        usTrack('cta_click', { market: 'US', offer: key, action: removing ? 'remove_addon' : 'add_addon', currency: 'USD' });
        refreshUsSelection();
      });
    });
    function setUsUpsellBusy(busy, activeButton) {
      usCheckoutPending = busy;
      [usUpsellAccept, usUpsellDecline].forEach(function (button) {
        if (!button) return;
        button.disabled = busy;
        button.toggleAttribute('aria-busy', busy && button === activeButton);
      });
      if (usBuyButton) {
        usBuyButton.disabled = busy;
        usBuyButton.toggleAttribute('aria-busy', busy);
      }
      root.querySelectorAll('[data-us-upsell-close]').forEach(function (button) { button.disabled = busy; });
    }
    function openUsUpsell() {
      if (!usUpsellModal || (!usSelection.premium && !usSelection.patches)) return;
      usLastFocus = document.activeElement;
      var title = usUpsellModal.querySelector('[data-us-upsell-title]');
      var copy = usUpsellModal.querySelector('[data-us-upsell-copy]');
      var price = usUpsellModal.querySelector('[data-us-upsell-price]');
      var badge = usUpsellModal.querySelector('[data-us-upsell-badge]');
      var order = usUpsellModal.querySelector('[data-us-upsell-order]');
      if (order) order.textContent = usSelectionText() + ' · ' + usFormat(usSelectionTotal());
      if (usSelection.premium) {
        if (title) title.textContent = gervixUsText('ADD THE BREATHING TRAINER?', '¿DESEAS AÑADIR EL ENTRENADOR RESPIRATORIO?');
        if (copy) copy.textContent = gervixUsText('Train stronger, more controlled breathing and complete your nightly routine for only $6 more.', 'Entrena una respiración más fuerte y controlada y completa tu rutina nocturna por solo $6 adicionales.');
        if (price) price.textContent = '+$6.00';
        if (badge) badge.textContent = '+$6';
        if (usUpsellAccept) usUpsellAccept.textContent = gervixUsText('YES, ADD IT FOR $6', 'SÍ, AÑADIR POR $6');
        if (usUpsellDecline) usUpsellDecline.textContent = gervixUsText('NO THANKS — CONTINUE TO CHECKOUT', 'NO, GRACIAS — CONTINUAR AL CHECKOUT');
      } else {
        if (title) title.textContent = gervixUsText('COMPLETE THE FULL SYSTEM?', '¿QUIERES COMPLETAR EL SISTEMA?');
        if (copy) copy.textContent = gervixUsText('Add the Premium Kit and Breathing Trainer bundle to your patch refill before checkout.', 'Añade el Kit Premium y el Entrenador Respiratorio a tus parches antes del checkout.');
        if (price) price.textContent = '$40.47';
        if (badge) badge.textContent = gervixUsText('BUNDLE', 'PAQUETE');
        if (usUpsellAccept) usUpsellAccept.textContent = gervixUsText('ADD KIT + TRAINER · $40.47', 'AÑADIR KIT + ENTRENADOR · $40.47');
        if (usUpsellDecline) usUpsellDecline.textContent = gervixUsText('NO THANKS — CONTINUE WITH PATCHES', 'NO, GRACIAS — CONTINUAR CON LOS PARCHES');
      }
      if (usUpsellError) usUpsellError.textContent = '';
      usUpsellModal.classList.add('is-open');
      usUpsellModal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('us-upsell-open');
      if (lenisRef) lenisRef.stop();
      usTrack('upsell_open', { market: 'US', offer: 'breathing_trainer', tier: usSelection.premium ? 'premium' : 'patches_only', currency: 'USD' });
      setTimeout(function () { if (usUpsellAccept) usUpsellAccept.focus(); else if (usUpsellDialog) usUpsellDialog.focus(); }, 80);
    }
    function closeUsUpsell() {
      if (!usUpsellModal || usCheckoutPending) return;
      usUpsellModal.classList.remove('is-open');
      usUpsellModal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('us-upsell-open');
      setUsUpsellBusy(false);
      if (lenisRef) lenisRef.start();
      if (usLastFocus && typeof usLastFocus.focus === 'function') usLastFocus.focus();
    }
    function usFetchWithTimeout(url, options) {
      if (!window.AbortController) return fetch(url, options);
      var controller = new AbortController();
      var timeout = setTimeout(function () { controller.abort(); }, 12000);
      var requestOptions = Object.assign({}, options, { signal: controller.signal });
      return fetch(url, requestOptions).finally(function () { clearTimeout(timeout); });
    }
    async function startUsCheckout(includeUpsell, activeButton) {
      var selectedKeys = [];
      if (includeUpsell) selectedKeys.push('total_pack');
      else if (usSelection.premium) selectedKeys.push('premium');
      if (usSelection.patches) selectedKeys.push('patches_120');
      var items = selectedKeys.map(function (selectedKey) {
        return { id: Number(usVariants[selectedKey]), quantity: 1, properties: { '_gervix_market': 'US', '_gervix_offer': selectedKey } };
      });
      if (items.some(function (item) { return !Number.isSafeInteger(item.id) || item.id <= 0; })) {
        if (usUpsellError) usUpsellError.textContent = gervixUsText('This option is temporarily unavailable. Please choose the other option.', 'Esta opción no está disponible temporalmente. Elige la otra opción.');
        return;
      }
      setUsUpsellBusy(true, activeButton);
      if (activeButton) activeButton.textContent = gervixUsText('OPENING SECURE CHECKOUT…', 'ABRIENDO CHECKOUT SEGURO…');
      var primaryOffer = includeUpsell ? 'total_pack' : usSelection.premium ? 'premium' : 'patches_120';
      usTrack(includeUpsell ? 'upsell_accept' : 'upsell_decline', { market: 'US', offer: 'breathing_trainer', action: includeUpsell ? 'add_upsell' : 'skip_upsell', currency: 'USD' });
      usTrack('checkout_start', { market: 'US', offer: primaryOffer, addons: usSelection.patches ? 'patches_120' : 'none', upsell: includeUpsell, currency: 'USD' });
      try {
        var clearResponse = await usFetchWithTimeout(usShopRoot + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
        if (!clearResponse.ok) throw new Error('clear_failed');
        var addResponse = await usFetchWithTimeout(usShopRoot + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!addResponse.ok) throw new Error('add_failed');
        usTrack('checkout_submit', { market: 'US', offer: primaryOffer, upsell: includeUpsell, currency: 'USD' });
        window.location.assign(GERVIX_US_SPANISH ? '/es/checkout' : '/en/checkout');
      } catch (error) {
        gervixClarityEvent('checkout_error', { market: 'US', status: 'cart_error' }, { upgrade: true });
        setUsUpsellBusy(false);
        if (usUpsellAccept) usUpsellAccept.textContent = usSelection.premium ? gervixUsText('YES, ADD IT FOR $6', 'SÍ, AÑADIR POR $6') : gervixUsText('ADD KIT + TRAINER · $40.47', 'AÑADIR KIT + ENTRENADOR · $40.47');
        if (usUpsellDecline) usUpsellDecline.textContent = usSelection.premium ? gervixUsText('NO THANKS — CONTINUE TO CHECKOUT', 'NO, GRACIAS — CONTINUAR AL CHECKOUT') : gervixUsText('NO THANKS — CONTINUE WITH PATCHES', 'NO, GRACIAS — CONTINUAR CON LOS PARCHES');
        if (usUpsellError) usUpsellError.textContent = gervixUsText('We could not open checkout. Please check your connection and try again.', 'No pudimos abrir el checkout. Revisa tu conexión e inténtalo de nuevo.');
      }
    }
    if (usBuyButton) usBuyButton.addEventListener('click', function () {
      if (!usSelection.premium && !usSelection.patches) return;
      usTrack('checkout_open', { market: 'US', offer: usSelection.premium ? 'premium' : 'patches_120', addons: usSelection.patches ? 'patches_120' : 'none', currency: 'USD' });
      openUsUpsell();
    });
    if (usUpsellAccept) usUpsellAccept.addEventListener('click', function () { startUsCheckout(true, usUpsellAccept); });
    if (usUpsellDecline) usUpsellDecline.addEventListener('click', function () { startUsCheckout(false, usUpsellDecline); });
    root.querySelectorAll('[data-us-upsell-close]').forEach(function (button) { button.addEventListener('click', closeUsUpsell); });
    if (usUpsellModal) usUpsellModal.addEventListener('click', function (event) { if (event.target === usUpsellModal) closeUsUpsell(); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && usUpsellModal && usUpsellModal.classList.contains('is-open')) closeUsUpsell(); });
    var usDealCountdown = root.querySelector('[data-us-deal-countdown]');
    function updateUsDealCountdown() {
      if (!usDealCountdown) return;
      var parts = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date()).forEach(function (part) { if (part.type !== 'literal') parts[part.type] = Number(part.value); });
      var remaining = Math.max(0, 86400 - ((parts.hour || 0) * 3600 + (parts.minute || 0) * 60 + (parts.second || 0)));
      var hours = Math.floor(remaining / 3600);
      var minutes = Math.floor((remaining % 3600) / 60);
      var seconds = remaining % 60;
      usDealCountdown.textContent = [hours, minutes, seconds].map(function (value) { return String(value).padStart(2, '0'); }).join(':');
      usDealCountdown.setAttribute('aria-label', GERVIX_US_SPANISH ? hours + ' horas, ' + minutes + ' minutos y ' + seconds + ' segundos restantes' : hours + ' hours, ' + minutes + ' minutes and ' + seconds + ' seconds remaining');
    }
    updateUsDealCountdown();
    setInterval(updateUsDealCountdown, 1000);
    refreshUsSelection();
    usTrack('landing_view', { market: 'US' });
    var usSeen = {};
    var usScroll = function () {
      var denominator = Math.max(1, document.documentElement.scrollHeight - innerHeight);
      var percent = Math.round(scrollY / denominator * 100);
      [25, 50, 75, 90].forEach(function (mark) { if (percent >= mark && !usSeen[mark]) { usSeen[mark] = true; usTrack('scroll_' + mark, { market: 'US' }); } });
    };
    addEventListener('scroll', usScroll, { passive: true });
    if ('IntersectionObserver' in window) {
      var usOfferObserver = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting && !usSeen.product) { usSeen.product = true; usTrack('product_section_view', { market: 'US' }); usOfferObserver.disconnect(); } }); }, { threshold: .3 });
      var usOfferSection = document.getElementById('comprar'); if (usOfferSection) usOfferObserver.observe(usOfferSection);
    }
    return;
  }

  var tiers = {
    single: { units: 1, price: 89900, onlinePrice: 84900, anchor: 149900, label: '1 GERVIX' },
    duo: { units: 2, price: 149900, onlinePrice: 139900, anchor: 299800, label: '2 GERVIX' },
    trio: { units: 3, price: 199900, onlinePrice: 184900, anchor: 449700, label: '3 GERVIX' }
  };
  Object.keys(tiers).forEach(function (key) {
    var price = Number(root.dataset[key + 'Price']) / 100;
    var onlinePrice = Number(root.dataset[key + 'OnlinePrice']) / 100;
    var anchor = Number(root.dataset[key + 'Anchor']) / 100;
    if (price > 0) tiers[key].price = price;
    if (onlinePrice > 0) tiers[key].onlinePrice = onlinePrice;
    if (anchor > 0) tiers[key].anchor = Math.max(anchor, tiers[key].price);
    if (root.dataset[key + 'Title']) tiers[key].label = root.dataset[key + 'Title'];
  });
  var selectedTier = 'single';
  var selectedPaymentMode = 'cod';
  var pendingCheckout = null;
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var modal = document.getElementById('modal');
  var form = document.getElementById('orderForm');
  var submitButton = document.getElementById('submitBtn');
  var formMessage = document.getElementById('formMsg');
  var progress = document.getElementById('submitProgress');
  var onlineButton = document.getElementById('payOnlineBtn');
  var thanksOverlay = document.getElementById('thanksOverlay');
  var money = function (n) { return '$' + Number(n).toLocaleString('es-CO'); };
  var pageStartedAt = Date.now();
  var activeIdempotencyKey = null;
  var codDeadlineAt = Date.parse(root.dataset.codDeadline || '2026-09-22T05:00:00.000Z');
  var codStateExpired = null;

  function codIsAvailable() {
    return Number.isFinite(codDeadlineAt) && Date.now() < codDeadlineAt;
  }

  function setCodAvailability() {
    var now = Date.now();
    var remaining = Math.max(0, codDeadlineAt - now);
    var expired = remaining <= 0;
    var colombiaNow = new Date(now - (5 * 60 * 60 * 1000));
    var colombiaYear = colombiaNow.getUTCFullYear();
    var colombiaMonth = colombiaNow.getUTCMonth();
    var colombiaDay = colombiaNow.getUTCDate();
    var dispatchAt = Date.UTC(colombiaNow.getUTCFullYear(), colombiaNow.getUTCMonth(), colombiaNow.getUTCDate(), 23, 0, 0, 0);
    var dispatchIsToday = now < dispatchAt;
    if (!dispatchIsToday) dispatchAt += 24 * 60 * 60 * 1000;
    var dispatchSeconds = Math.floor(Math.max(0, dispatchAt - now) / 1000);
    var dispatchHours = Math.floor(dispatchSeconds / 3600);
    var dispatchMinutes = Math.floor((dispatchSeconds % 3600) / 60);
    var dispatchSecondsOnly = dispatchSeconds % 60;
    var colombiaDaySerial = Math.floor(Date.UTC(colombiaYear, colombiaMonth, colombiaDay) / (24 * 60 * 60 * 1000));
    var dailyStockUnits = 2 + (((colombiaDaySerial * 17) + 11) % 3);
    var stockResetAt = Date.UTC(colombiaYear, colombiaMonth, colombiaDay + 1, 5, 0, 0, 0);
    var stockSeconds = Math.floor(Math.max(0, stockResetAt - now) / 1000);
    var stockHours = Math.floor(stockSeconds / 3600);
    var stockMinutes = Math.floor((stockSeconds % 3600) / 60);
    var stockSecondsOnly = stockSeconds % 60;
    root.querySelectorAll('[data-daily-stock-units]').forEach(function (unit) {
      unit.textContent = String(dailyStockUnits);
    });
    root.querySelectorAll('[data-daily-stock-countdown]').forEach(function (countdown) {
      countdown.textContent = String(stockHours).padStart(2, '0') + ':' + String(stockMinutes).padStart(2, '0') + ':' + String(stockSecondsOnly).padStart(2, '0');
    });
    root.querySelectorAll('[data-cod-countdown]').forEach(function (countdown) {
      countdown.textContent = String(dispatchHours).padStart(2, '0') + ':' + String(dispatchMinutes).padStart(2, '0') + ':' + String(dispatchSecondsOnly).padStart(2, '0');
    });
    root.querySelectorAll('[data-cod-deadline-title]').forEach(function (title) {
      title.textContent = dispatchIsToday
        ? 'COMPRA ANTES DE LAS 6:00 P. M. PARA ENTRAR EN EL DESPACHO DE HOY'
        : 'COMPRA ANTES DE LAS 6:00 P. M. PARA ENTRAR EN EL PRÓXIMO DESPACHO';
    });
    root.querySelectorAll('[data-cod-deadline-copy]').forEach(function (copy) {
      copy.textContent = dispatchIsToday
        ? 'Tiempo restante para el corte de despacho de hoy · hora Colombia.'
        : 'El contador ya está corriendo para el siguiente corte · hora Colombia.';
    });
    if (codStateExpired === expired) return;
    codStateExpired = expired;
    root.classList.toggle('cod-expired', expired);
    if (!expired) return;
    var benefit = root.querySelector('[data-cod-benefit]');
    var note = root.querySelector('[data-cod-note]');
    var finalCopy = root.querySelector('[data-cod-final-copy]');
    var strip = root.querySelector('[data-cod-strip]');
    if (benefit) benefit.textContent = 'Envío GRATIS + Pago seguro en línea';
    if (note) note.textContent = '🔒 Pago en línea seguro · Checkout protegido';
    if (finalCopy) finalCopy.textContent = 'Pídelo hoy con pago seguro en línea. Garantía de 30 días — los detalles están en los términos.';
    if (strip) strip.textContent = 'PAGO SEGURO EN LÍNEA';
    root.querySelectorAll('.band-row span').forEach(function (item) {
      if (item.textContent.trim() === 'PAGO CONTRA ENTREGA') item.textContent = 'PAGO ONLINE';
    });
    root.querySelectorAll('.nav-cta, .hero-cta, .final .btn-lg').forEach(function (button) {
      var label = button.querySelector('span');
      if (label) label.innerHTML = 'Comprar · envío prioritario gratis <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden="true"><path d="M1 6h15m0 0L11 1m5 5l-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    });
    root.querySelectorAll('.offer .btn-alt').forEach(function (button) {
      var label = button.querySelector('span');
      if (label) label.innerHTML = 'Comprar · envío prioritario gratis <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden="true"><path d="M1 6h15m0 0L11 1m5 5l-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    });
    root.querySelectorAll('[data-gervix-tier]').forEach(function (button) {
      var label = button.querySelector('span');
      if (label) label.innerHTML = 'Comprar · envío prioritario gratis <svg width="18" height="12" viewBox="0 0 18 12" fill="none" aria-hidden="true"><path d="M1 6h15m0 0L11 1m5 5l-5 5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
    });
    if (selectedPaymentMode === 'cod' && modal && modal.classList.contains('open')) {
      setModalMode('online');
      updateSummary();
      if (formMessage) {
        formMessage.textContent = 'El pago contraentrega finalizó. Puedes continuar con pago seguro en línea.';
        formMessage.className = 'form-msg ok';
      }
    }
  }

  function secureId(prefix) {
    var bytes = new Uint8Array(18);
    if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
    else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    return prefix + '_' + Array.from(bytes).map(function (b) { return b.toString(16).padStart(2, '0'); }).join('');
  }
  function readCookie(name) {
    var found = document.cookie.split(';').map(function (v) { return v.trim(); }).find(function (v) { return v.indexOf(name + '=') === 0; });
    return found ? decodeURIComponent(found.slice(name.length + 1)) : '';
  }
  function stableIdentifier(storage, storageKey, cookieKey, prefix, maxAge) {
    var value = '';
    try { value = storage.getItem(storageKey) || ''; } catch (error) { value = ''; }
    if (!value) value = readCookie(cookieKey);
    if (!new RegExp('^' + prefix + '_[a-f0-9]{32,64}$').test(value)) value = secureId(prefix);
    try { storage.setItem(storageKey, value); } catch (error) { /* Cookie supplies a second persistence channel. */ }
    document.cookie = cookieKey + '=' + encodeURIComponent(value) + '; path=/; max-age=' + maxAge + '; SameSite=Lax; Secure';
    return value;
  }
  var visitorId = stableIdentifier(window.localStorage, 'gervix_visitor_id', 'gervix_vid', 'gv', 31536000);
  var sessionId = stableIdentifier(window.sessionStorage, 'gervix_session_id', 'gervix_sid', 'gs', 1800);
  function collectSignals(honeypot) {
    var query = new URLSearchParams(window.location.search);
    var ua = navigator.userAgent || '';
    return {
      visitorId: visitorId,
      sessionId: sessionId,
      idempotencyKey: activeIdempotencyKey || (activeIdempotencyKey = secureId('gi')),
      fbp: readCookie('_fbp') || undefined,
      fbc: readCookie('_fbc') || undefined,
      fbclid: query.get('fbclid') || undefined,
      sourceUrl: window.location.href.slice(0, 500),
      timezone: (Intl.DateTimeFormat().resolvedOptions().timeZone || '').slice(0, 80),
      language: (navigator.language || '').slice(0, 30),
      screen: window.screen ? window.screen.width + 'x' + window.screen.height : '',
      automation: {
        webdriver: navigator.webdriver === true,
        headless: /HeadlessChrome|PhantomJS|selenium/i.test(ua),
        zeroPlugins: typeof navigator.plugins !== 'undefined' && navigator.plugins.length === 0,
        impossibleTiming: Date.now() - pageStartedAt < 700,
        honeypot: Boolean(honeypot)
      }
    };
  }
  var metaOnce = {};
  function trackMetaEvent(name, params, eventId) {
    gervixClarityEvent(name, params, { upgrade: name === 'checkout_start' });
    if (typeof window.fbq !== 'function') return;
    try { window.fbq('trackCustom', name, params || {}, { eventID: eventId || secureId('me') }); } catch (error) { /* Meta nunca interrumpe la compra. */ }
  }
  function trackMetaStandard(name, params, eventId) {
    gervixClarityEvent('meta_' + name.toLowerCase(), params, { upgrade: name === 'InitiateCheckout' || name === 'Purchase' });
    if (typeof window.fbq !== 'function') return;
    try { window.fbq('track', name, params || {}, { eventID: eventId || secureId('me') }); } catch (error) { /* Meta nunca interrumpe la compra. */ }
  }
  function trackMetaOnce(name, params) {
    if (metaOnce[name]) return; metaOnce[name] = true;
    trackMetaEvent(name, params, name + '_' + sessionId);
  }

  function tierData(key) { return tiers[key] || tiers.single; }
  function activePrice(data) { return selectedPaymentMode === 'online' ? data.onlinePrice : data.price; }
  function configuredVariant(key) {
    var own = root.dataset[key + 'Variant'];
    return { id: own || '', quantity: 1 };
  }
  function metaCommerceData(key, mode) {
    var data = tierData(key);
    var variant = configuredVariant(key);
    var value = mode === 'online' ? data.onlinePrice : data.price;
    return {
      content_ids: variant.id ? [String(variant.id)] : [],
      content_name: data.label,
      content_type: 'product',
      contents: variant.id ? [{ id: String(variant.id), quantity: 1, item_price: value }] : [],
      value: value,
      currency: 'COP',
      payment_method: mode
    };
  }
  function updateSummary() {
    var data = tierData(selectedTier);
    var price = activePrice(data);
    var title = root.dataset[selectedTier + 'Title'] || data.label;
    var name = document.getElementById('sumName');
    var qty = document.getElementById('sumQty');
    var total = document.getElementById('sumTotal');
    var anchor = document.getElementById('sumAnchor');
    var saved = document.getElementById('sumSaved');
    var pill = document.getElementById('sumDiscountPill');
    if (name) name.textContent = title || data.label;
    if (qty) qty.textContent = String(data.units);
    if (total) total.textContent = money(price);
    if (anchor) anchor.textContent = money(data.anchor);
    if (saved) saved.textContent = 'Ahorras ' + money(data.anchor - price) + ' hoy';
    if (pill) pill.textContent = '−' + Math.round((1 - price / data.anchor) * 100) + '%';
  }
  function setModalMode(mode) {
    var online = mode === 'online';
    selectedPaymentMode = online ? 'online' : 'cod';
    var title = document.getElementById('modalTitle');
    var subtitle = document.getElementById('modalSub');
    var priceNote = document.getElementById('sumPriceNote');
    if (modal) modal.classList.toggle('online-mode', online);
    if (title) title.textContent = online ? 'Elige tu cantidad' : 'Finaliza tu pedido';
    if (subtitle) subtitle.textContent = online ? 'Precio especial por pago en línea y envío prioritario.' : 'Solo llena tus datos. Pagas en efectivo cuando llegue. 🚚';
    if (priceNote) priceNote.textContent = online ? 'Precio final en línea · envío prioritario' : 'Pagas al recibir';
    if (onlineButton) onlineButton.textContent = online ? 'Continuar al pago en línea' : 'PAGAR EN LÍNEA + ENVÍO PRIORITARIO + AHORRO';
  }
  function openForm(key, mode) {
    selectedTier = key || 'single';
    var requestedMode = mode || 'cod';
    if (requestedMode === 'cod' && !codIsAvailable()) requestedMode = 'online';
    trackMetaEvent('checkout_open', { tier: selectedTier, payment_method: requestedMode === 'online' ? 'online' : 'cod' });
    trackMetaStandard('InitiateCheckout', metaCommerceData(selectedTier, requestedMode), 'initiate_checkout_' + sessionId + '_' + selectedTier + '_' + requestedMode);
    setModalMode(requestedMode);
    updateSummary();
    if (modal) {
      modal.classList.add('open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('modal-open');
      if (lenisRef) lenisRef.stop();
      setTimeout(function () {
        var target = requestedMode === 'online' ? onlineButton : modal.querySelector('input:not(.hp-field)');
        if (target) target.focus();
      }, 120);
    }
  }
  function closeForm() {
    if (!modal) return;
    modal.classList.remove('open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
    if (lenisRef) lenisRef.start();
  }
  function moveTier(delta) {
    var order = ['single', 'duo', 'trio'];
    var index = Math.max(0, Math.min(2, order.indexOf(selectedTier) + delta));
    selectedTier = order[index];
    updateSummary();
  }

  async function replaceCartWithTier(key, properties) {
    var configured = configuredVariant(key);
    if (!configured.id) throw new Error('Selecciona el producto de ' + tierData(key).units + ' dilatador(es) en Tienda online → Personalizar → Landing GERVIX.');
    var clearResponse = await fetch(shopRoot + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' }
    });
    if (!clearResponse.ok) throw new Error('No se pudo reiniciar el carrito. Recarga la página e intenta de nuevo.');
    var addResponse = await fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(configured.id), quantity: configured.quantity, properties: properties || {} }]
      })
    });
    if (!addResponse.ok) throw new Error('No se pudo agregar el producto seleccionado. Revisa que esté publicado y disponible.');
    var cleanAttributes = {
      Nombre: '', WhatsApp: '', Direccion: '', Complemento: '', Ciudad: '', Departamento: '',
      'Codigo postal': '', Correo: '', Producto: '', Total: '', Referencia: '', 'Forma de pago': ''
    };
    Object.keys(properties || {}).forEach(function (name) { cleanAttributes[name] = properties[name]; });
    var updateResponse = await fetch(shopRoot + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: cleanAttributes, note: '' })
    });
    if (!updateResponse.ok) throw new Error('El producto se agregó, pero no fue posible guardar los datos del pedido. Intenta nuevamente.');
    return addResponse.json();
  }

  async function clearCartSilently() {
    try {
      await fetch(shopRoot + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } });
    } catch (error) {
      /* El pedido ya existe en Shopify; un fallo al limpiar el carrito no debe duplicarlo. */
    }
  }

  async function createCodOrder(details, honeypot) {
    if (!codIsAvailable()) throw new Error('El pago contraentrega ya finalizó. Continúa con pago en línea.');
    var endpoint = String(root.dataset.codEndpoint || '/apps/gervix-cod/order');
    var body = JSON.stringify({ tier: details.tier, firstName: details.firstName, lastName: details.lastName, phone: details.customerPhone,
      email: details.email, address1: details.address1, address2: details.address2, city: details.cityName, province: details.province,
      zip: details.zip, signals: collectSignals(honeypot) });
    var response, result;
    for (var attempt = 0; attempt < 4; attempt++) {
      response = await fetch(endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body });
      try { result = await response.json(); } catch (error) { result = null; }
      if (response.status !== 202 || !result || !result.processing) break;
      await new Promise(function (resolve) { setTimeout(resolve, 1200 + attempt * 500); });
    }
    if (!response.ok || !result || !result.ok || !result.orderName) {
      throw new Error((result && result.message) || 'No se pudo crear el pedido. Intenta nuevamente.');
    }
    return result;
  }

  function sendBrowserPurchase(purchase) {
    if (!purchase || !purchase.eventId || typeof window.fbq !== 'function') return;
    try {
      window.fbq('track', 'Purchase', { value: Number(purchase.value), currency: purchase.currency || 'COP', content_ids: purchase.contentIds || [], content_type: 'product' }, { eventID: purchase.eventId });
    } catch (error) { /* CAPI remains authoritative and records its own response. */ }
  }

  function checkoutUrl(details) {
    var url = shopRoot + 'checkout';
    if (!details) return url;
    var params = new URLSearchParams();
    params.set('checkout[email]', details.email || '');
    params.set('checkout[shipping_address][first_name]', details.firstName || '');
    params.set('checkout[shipping_address][last_name]', details.lastName || '');
    params.set('checkout[shipping_address][phone]', details.customerPhone || '');
    params.set('checkout[shipping_address][address1]', details.address1 || '');
    params.set('checkout[shipping_address][address2]', details.address2 || '');
    params.set('checkout[shipping_address][city]', details.cityName || '');
    params.set('checkout[shipping_address][province]', details.province || '');
    params.set('checkout[shipping_address][zip]', details.zip || '');
    return url + '?' + params.toString();
  }

  function goToCheckout() {
    window.location.assign(checkoutUrl(pendingCheckout));
  }

  async function startOnlineCheckout(key, button) {
    var data = tierData(key);
    var onlinePrice = data.onlinePrice;
    var original = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.textContent = 'Abriendo pago seguro…'; }
    if (formMessage) { formMessage.textContent = ''; formMessage.className = 'form-msg'; }
    try {
      trackMetaEvent('checkout_start', { tier: key, payment_method: 'online', value: onlinePrice, currency: 'COP' });
      pendingCheckout = null;
      var signals = collectSignals(false);
      await replaceCartWithTier(key, { Producto: data.label, Total: money(onlinePrice), 'Forma de pago': 'Pago en línea', 'Envío': 'Prioritario',
        'Descuento online': money(data.price - onlinePrice), 'Garantía': 'Devolución inmediata del 100% una vez aprobado el caso',
        'Contacto garantía': 'contacto@gervix.com', gervix_visitor_id: signals.visitorId,
        gervix_session_id: signals.sessionId, _fbp: signals.fbp || '', _fbc: signals.fbc || '', fbclid: signals.fbclid || '', gervix_source_url: signals.sourceUrl || '' });
      trackMetaEvent('checkout_submit', { tier: key, payment_method: 'online', value: onlinePrice, currency: 'COP' });
      goToCheckout();
    } catch (error) {
      gervixClarityEvent('checkout_error', { market: 'CO', payment_method: 'online', status: 'cart_error' }, { upgrade: true });
      if (button) { button.disabled = false; button.innerHTML = original; }
      if (formMessage && modal && modal.classList.contains('open')) {
        formMessage.textContent = error.message || 'No fue posible abrir el pago. Intenta nuevamente.';
        formMessage.className = 'form-msg err';
      } else {
        window.alert(error.message || 'No fue posible abrir el pago. Intenta nuevamente.');
      }
    }
  }

  function showThanks(details) {
    details = details || {};
    closeForm();
    if (!thanksOverlay) return;
    var name = document.getElementById('thanksName');
    var order = document.getElementById('thanksOrder');
    var items = document.getElementById('thanksItems');
    var total = document.getElementById('thanksTotal');
    var whatsapp = document.getElementById('thanksWa');
    if (name) name.textContent = details.firstName || 'tú';
    if (order) order.textContent = details.orderName || 'Pedido creado';
    if (items) items.textContent = details.label || tierData(details.tier).label;
    if (total) total.textContent = money(details.total || tierData(details.tier).price);
    if (whatsapp) {
      var phone = String(root.dataset.ownerWhatsapp || '573234528295').replace(/\D/g, '');
      var orderName = String(details.orderName || 'pendiente');
      if (orderName.charAt(0) !== '#') orderName = '#' + orderName;
      var message = 'Hola GERVIX, quiero saber el estado de mi orden ' +
        orderName +
        '. ¿Ya está confirmada y en proceso de envío? Muchas gracias.';
      whatsapp.href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message);
    }
    thanksOverlay.classList.add('open');
    thanksOverlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
    if (lenisRef) lenisRef.stop();
  }

  root.querySelectorAll('.nav-cta, .hero-cta, .offer .btn-lg, .final .btn-lg').forEach(function (button) {
    button.setAttribute('type', 'button');
    button.addEventListener('click', function () { var mode = codIsAvailable() ? 'cod' : 'online'; trackMetaEvent('cta_click', { location: button.closest('section') ? button.closest('section').className : 'navigation', payment_method: mode }); trackMetaStandard('AddToCart', metaCommerceData('single', mode), 'add_to_cart_' + sessionId + '_single_' + mode); openForm('single', mode); });
  });
  root.querySelectorAll('.offer .btn-alt').forEach(function (button) {
    button.setAttribute('type', 'button');
    button.addEventListener('click', function () { trackMetaEvent('cta_click', { location: 'offer', payment_method: 'online' }); trackMetaStandard('AddToCart', metaCommerceData('single', 'online'), 'add_to_cart_' + sessionId + '_single_online'); openForm('single', 'online'); });
  });
  root.querySelectorAll('[data-gervix-tier]').forEach(function (button) {
    button.addEventListener('click', function () { var tierKey = button.dataset.gervixTier || 'single'; var mode = codIsAvailable() ? 'cod' : 'online'; trackMetaEvent('bundle_' + tierData(tierKey).units + '_click', { tier: tierKey, value: activePrice(tierData(tierKey)), currency: 'COP', payment_method: mode }); trackMetaStandard('AddToCart', metaCommerceData(tierKey, mode), 'add_to_cart_' + sessionId + '_' + tierKey + '_' + mode); openForm(tierKey, mode); });
  });
  var quantityButtons = root.querySelectorAll('.qty-ctrl button');
  if (quantityButtons[0]) quantityButtons[0].addEventListener('click', function () { moveTier(-1); });
  if (quantityButtons[1]) quantityButtons[1].addEventListener('click', function () { moveTier(1); });
  var closeButton = document.getElementById('modalCloseBtn');
  if (closeButton) closeButton.addEventListener('click', closeForm);
  if (modal) modal.addEventListener('click', function (event) { if (event.target === modal) closeForm(); });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && (!thanksOverlay || !thanksOverlay.classList.contains('open'))) closeForm();
  });
  if (onlineButton) onlineButton.addEventListener('click', function () {
    startOnlineCheckout(selectedTier, onlineButton);
  });

  if (form) form.addEventListener('submit', async function (event) {
    event.preventDefault();
    if (!codIsAvailable()) {
      setModalMode('online');
      updateSummary();
      if (formMessage) { formMessage.textContent = 'El pago contraentrega ya finalizó. Continúa con pago seguro en línea.'; formMessage.className = 'form-msg ok'; }
      if (onlineButton) onlineButton.focus();
      return;
    }
    var honeypotValue = form.querySelector('[name="website"]').value;
    var data = new FormData(form);
    var firstName = String(data.get('contact[first_name]') || '');
    var lastName = String(data.get('contact[last_name]') || '');
    var tier = tierData(selectedTier);
    trackMetaEvent('checkout_start', { tier: selectedTier, payment_method: 'cod' });
    var customer = {
      Nombre: (firstName + ' ' + lastName).trim(),
      WhatsApp: String(data.get('contact[phone]') || ''),
      Direccion: String(data.get('contact[address1]') || ''),
      Complemento: String(data.get('contact[address2]') || ''),
      Ciudad: String(data.get('contact[city]') || ''),
      Departamento: String(data.get('contact[province]') || ''),
      'Codigo postal': String(data.get('contact[zip]') || ''),
      Correo: String(data.get('contact[email]') || ''),
      Producto: tier.label,
      Total: money(tier.price),
      'Forma de pago': 'Contraentrega'
    };
    var details = {
      firstName: firstName,
      lastName: lastName,
      fullName: customer.Nombre,
      customerPhone: customer.WhatsApp,
      email: customer.Correo,
      address1: customer.Direccion,
      address2: customer.Complemento,
      cityName: customer.Ciudad,
      province: customer.Departamento,
      zip: customer['Codigo postal'],
      address: [customer.Direccion, customer.Complemento].filter(Boolean).join(', '),
      city: [customer.Ciudad, customer.Departamento].filter(Boolean).join(', '),
      tier: selectedTier,
      label: tier.label,
      total: tier.price
    };
    if (submitButton) { submitButton.disabled = true; submitButton.textContent = 'Creando pedido…'; }
    if (progress) progress.classList.add('show');
    if (formMessage) { formMessage.textContent = ''; formMessage.className = 'form-msg'; }
    try {
      trackMetaEvent('checkout_submit', { tier: selectedTier, payment_method: 'cod', value: tier.price, currency: 'COP' });
      var createdOrder = await createCodOrder(details, honeypotValue);
      gervixClarityEvent('order_created', { market: 'CO', payment_method: 'cod', tier: selectedTier, status: 'success' }, { upgrade: true });
      details.orderName = createdOrder.orderName;
      details.label = createdOrder.title || details.label;
      if (createdOrder.total && createdOrder.total.amount) details.total = Number(createdOrder.total.amount);
      form.reset();
      sendBrowserPurchase(createdOrder.browserPurchase);
      if (createdOrder.browserCodPayment) trackMetaEvent('cod_payment', { value: Number(createdOrder.browserCodPayment.value), currency: createdOrder.browserCodPayment.currency || 'COP', content_ids: createdOrder.browserCodPayment.contentIds || [], content_type: 'product' }, createdOrder.browserCodPayment.eventId);
      activeIdempotencyKey = null;
      showThanks(details);
      clearCartSilently();
      if (submitButton) { submitButton.disabled = false; submitButton.textContent = 'Confirmar pedido contra entrega'; }
      if (progress) progress.classList.remove('show');
    } catch (error) {
      gervixClarityEvent('order_error', { market: 'CO', payment_method: 'cod', tier: selectedTier, status: 'failed' }, { upgrade: true });
      if (formMessage) { formMessage.textContent = error.message || 'Ocurrió un problema. Intenta nuevamente.'; formMessage.className = 'form-msg err'; }
      if (submitButton) { submitButton.disabled = false; submitButton.textContent = 'Confirmar pedido contra entrega'; }
      if (progress) progress.classList.remove('show');
    }
  });

  setCodAvailability();
  window.setInterval(setCodAvailability, 1000);
  updateSummary();
  trackMetaOnce('landing_view', { page: 'gervix_landing' });
  var scrollMarks = [25, 50, 75, 90];
  var scrollDepthFrame = 0;
  function trackScrollDepth() {
    if (scrollDepthFrame) return;
    scrollDepthFrame = requestAnimationFrame(function () {
      var height = Math.max(document.documentElement.scrollHeight - window.innerHeight, 1), percent = Math.round(window.scrollY / height * 100);
      scrollMarks = scrollMarks.filter(function (mark) { if (percent < mark) return true; trackMetaOnce('scroll_' + mark, { percent: mark }); return false; });
      scrollDepthFrame = 0;
      if (!scrollMarks.length) window.removeEventListener('scroll', trackScrollDepth);
    });
  }
  window.addEventListener('scroll', trackScrollDepth, { passive: true });
  var productSection = document.getElementById('comprar');
  if (productSection && 'IntersectionObserver' in window) { var observer = new IntersectionObserver(function (entries) { if (entries.some(function (entry) { return entry.isIntersecting; })) { trackMetaOnce('product_section_view', { section: 'comprar' }); trackMetaStandard('ViewContent', metaCommerceData('single', 'online'), 'view_content_' + sessionId); observer.disconnect(); } }, { threshold: .35 }); observer.observe(productSection); }
  window.GervixShopify = { openForm: openForm, closeForm: closeForm };
})();


(function () {
  if (!document.getElementById('gervix-root')) return;
  /* La secuencia comienza antes de descargar GSAP, así siempre caben las tres palabras en 2,5 s. */
  document.body.dataset.gervixIntroManaged = 'true';
  var introWords = GERVIX_US_MARKET && !GERVIX_US_SPANISH ? ['BREATHE', 'REST', 'LIVE'] : ['RESPIRA', 'DESCANSA', 'VIVE'];
  var introSubs = GERVIX_US_MARKET && !GERVIX_US_SPANISH ? ['Preparing deeper rest…', 'Supporting nasal airflow…', 'Your experience is ready…'] : ['Preparando tu descanso…', 'Alineando fosas nasales…', 'Cargando noche perfecta…'];
  var introLastPhase = -1;
  var introSequenceTimer = setInterval(function () {
    var elapsed = performance.now() - gervixIntroStartedAt;
    var visibleDuration = GERVIX_INTRO_TOTAL_MS - GERVIX_INTRO_FADE_MS;
    var phase = Math.min(2, Math.floor(elapsed / 700));
    var wordEl = document.getElementById('introWord');
    var subEl = document.getElementById('introSub');
    var countEl = document.getElementById('introCount');
    var barEl = document.getElementById('introBar');
    if (phase !== introLastPhase && wordEl) {
      introLastPhase = phase;
      wordEl.style.animation = 'none'; wordEl.offsetHeight; wordEl.style.animation = '';
      wordEl.textContent = introWords[phase];
      if (subEl) subEl.textContent = introSubs[phase];
    }
    var progress = Math.min(100, Math.round(elapsed / visibleDuration * 100));
    if (countEl) countEl.textContent = String(progress).padStart(3, '0');
    if (barEl) barEl.style.width = progress + '%';
    if (progress >= 100) clearInterval(introSequenceTimer);
  }, 40);
  function load(src, test) {
    if (test()) return Promise.resolve();
    return new Promise(function (resolve) {
      var script = document.createElement('script');
      script.src = src; script.async = true; script.onload = resolve; script.onerror = resolve;
      document.head.appendChild(script);
    });
  }
  var intro = document.getElementById('intro');
  if (intro) intro.addEventListener('click', function () {
    intro.style.display = 'none';
    var panel = document.getElementById('introPanel'); if (panel) panel.style.display = 'none';
    document.body.classList.remove('lock');
  });
  Promise.resolve()
    .then(function () { return load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js', function () { return !!window.gsap; }); })
    .then(function () { return load('https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js', function () { return !!window.ScrollTrigger; }); })
    .then(function () { return GERVIX_ENHANCED_MOTION ? load('https://cdn.jsdelivr.net/npm/lenis@1.1.14/dist/lenis.min.js', function () { return !!window.Lenis; }) : Promise.resolve(); })
    .then(function () { try { initGervix(); } catch (error) { console.error(error); document.getElementById('gervix-root')?.classList.add('gsap-off'); } });
  var introFallbackDelay = Math.max(0, GERVIX_INTRO_TOTAL_MS - (performance.now() - gervixIntroStartedAt));
  setTimeout(function () {
    var introEl = document.getElementById('intro'); if (introEl) introEl.style.display = 'none';
    var panelEl = document.getElementById('introPanel'); if (panelEl) panelEl.style.display = 'none';
    document.body.classList.remove('lock');
    gervixClarityEvent('intro_complete', { status: 'ready' }, { once: true });
  }, introFallbackDelay);
})();
